<Suspense><div class="appContainer"><router-view></router-view></div></Suspense>